import type { Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';
import type { PageSettings, PageSettingsUpdateRequest } from '@common/types/page-settings.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class PageSettingsHttpService extends BaseHttpService {
    public getSitePageSettings(siteId: string, pageId: string): Observable<PageSettings> {
        return this.http
            .get<HttpDataResponse<PageSettings>>(this.formatApiUrl(`sites/${siteId}/pages/${pageId}/settings`))
            .pipe(
                shareReplay(),
                map((res) => res.data)
            );
    }

    public updatePageSettings(
        siteId: number,
        pageId: number,
        settings: PageSettingsUpdateRequest
    ): Observable<PageSettings> {
        const formData = new FormData();

        Object.keys(settings).forEach((key: string) => {
            if (settings[key] || settings[key] === 0) {
                formData.append(key, settings[key]);
            }
        });

        return this.http
            .post<
                HttpDataResponse<PageSettings>
            >(this.formatApiUrl(`sites/${siteId}/pages/${pageId}/settings`), formData)
            .pipe(
                shareReplay(),
                map((res) => res.data)
            );
    }
}
